import { isEmpty as a, isNotEmpty as n } from "../../helpers/stringHelper.js";
import "clsx";
import "react";
const s = '[TextArea - Accessibility Error] Se a prop "label" n\xE3o for informada no TextArea \xE9 necess\xE1rio informar o atributo "aria-label" para garantir melhor acessibilidade no formul\xE1rio.',
  l = '[TextArea - Accessibility Error] Quando o componente est\xE1 com state="loading" a propriedade stateMessage \xE9 obrigat\xF3ria.',
  x = "[TextArea - Error] Para utiliza\xE7\xE3o da label com no componente \xE9 obrigat\xF3rio a utiliza\xE7\xE3o de um id v\xE1lido.",
  E = _ref => {
    let {
      "aria-label": r,
      id: e,
      label: o,
      state: i,
      stateMessage: t
    } = _ref;
    if (a(o) && a(r)) throw new Error(s);
    if (n(o) && a(e)) throw new Error(x);
    if (i === "loading" && a(t)) throw new Error(l);
  },
  d = r => r ? r.toString().length : 0,
  m = r => {
    if (r && Number.isInteger(r) && r >= 1) return r;
  };
export { d as getQuantTyped, E as runTextareaValidations, m as validation };